<template>
  <div>
    <Form ref="addModel" :model="addModel" :rules="ruleValidate" :label-width="100" inline>
      <FormItem label="组织名称" prop="organizationName">
        <Input class="w-250" v-model="addModel.organizationName"></Input>
      </FormItem>
    </Form>
    <div class="text-center">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('addModel')">确 定</Button>
    </div>
 
  </div>
</template>
<script>

export default {
  data: function () {
    return {
      addModel: {
        organizationName: "",
        createUser:"",
      },
      ruleValidate: {
        organizationName: [
          {
            required: true,
            message: "组织名称不能为空",
          },
        ],
      },
    };
  },

  created: function () {
   this.addModel.createUser = this.$store.state.name;
  },

  methods: {
     returnBack: function () {
      this.$emit("close");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api.post(`organization/create?organizationName=${this.addModel.organizationName}&createUser=${this.addModel.createUser}`).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("添加成功");
              // this.addModel.organizationName="";
              this.$refs["addModel"].resetFields();
              this.returnBack();
             this.$emit("loadData");
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped>
</style>